import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import 'dayjs/locale/ja'
import 'dayjs/locale/vi'
import 'dayjs/locale/en'
import { i18n } from './i18n'

// Required for chaild-api getDayjsInstanceTz() (e.g. Parents Record dropdown)
dayjs.extend(utc)
dayjs.extend(timezone)

// Sync dayjs locale with i18n locale
export function syncDayjsLocale() {
  const currentLocale = i18n.global.locale.value
  dayjs.locale(currentLocale)
}

// Set initial locale
syncDayjsLocale()

// Watch for locale changes
export function setupDayjsLocaleSync() {
  // Sync whenever locale changes
  const originalSetLocale = i18n.global.locale
  Object.defineProperty(i18n.global, 'locale', {
    get() {
      return originalSetLocale
    },
    set(value) {
      originalSetLocale.value = value
      dayjs.locale(value)
    }
  })
}

export default dayjs
